import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	headerCompass: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	headerJira: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	headerCompass: {
		id: 'project-components.compass-header',
		defaultMessage:
			'Group and track work around components of your software architecture, cataloged in Compass. <link>Learn more about Compass components</link>',
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
	headerJira: {
		id: 'project-components.jira-header',
		defaultMessage:
			// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
			'Group and assign work around features, departments, or workstreams specific to your project. <link>Learn more about Jira Components</link>',
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
});
export default messages;
